import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    module:null,
    type:null,
    page:0,
    pageSize:null,
    activeTab:0,
    pathname:"",
    filters:null,
    searchOptions:null
}

const paginationSlice = createSlice({
    name: 'pagination',
    initialState,
    reducers: {
        setPaginationFiled(state, action) {
            state.type = action.payload.type
            state.page = action.payload.page
            state.pageSize = action.payload.pageSize
            state.activeTab = action.payload.activeTab
            state.module = action.payload.module
            state.pathname = action.payload.pathname
            state.filters = action.payload.filters
            state.searchOptions = action.payload.searchOptions
        },
        resetPaginationFields(state) {
            state.fields = initialState
        }
    },
})

export const { setPaginationFiled, resetPaginationFields } = paginationSlice.actions
export default paginationSlice.reducer
